import { render } from "./Semakan.vue?vue&type=template&id=472f36fc"
import script from "./Semakan.vue?vue&type=script&lang=js"
export * from "./Semakan.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__